import { useEffect, useContext, useState } from "react";

import Context from "../../../../context";

import axios from "axios";
import ManageAccountHeader from "./ManageAccountHeader";
import ManageAccountListPage from "./ManageAccountListPage";
import ManageAccountAutoPayPage from "./ManageAccountAutoPayPage";
import ManageAccountAddAccountPage from "./ManageAccountAddAccountPage";
import ManageAccountDownloadDataPage from "./ManageAccountDownloadDataPage";
import ContactPage from "../../ContactPage/ContactPage";

import { useHistory } from "react-router";
import { API_URL } from "../../../data/constants";

export default function ManageAccountsPage() {
  const { contextState, setContextState } = useContext(Context);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [numItems, setNumItems] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const username = localStorage.getItem("username");
  const userRole = localStorage.getItem("userRole");

  const history = useHistory();

  useEffect(() => {
      setIsLoading(true);
      axios
      .post(
          API_URL + "/Accounts/Paged",
          {
            pageNumber: currentPage,
            pageSize: perPage,
            customerId: null,
            customerNumber: null,
            masterCustomerId: null,
            userName: username,
            userRole: userRole,
          },
          {
            headers: {
              Authorization: localStorage.getItem("accessToken"),
            },
          })
        .then((res) => {
          if (res.data.accounts.length === 1) {
            setContextState({
              ...contextState,
              accounts: res.data.accounts,
              currentAccount: res.data.accounts[0],
              currentAccountId: res.data.accounts[0].customerNumber
            });
            history.push(`account/${res.data.accounts[0].customerNumber}/detail`);
          }
          else{
            setContextState({ ...contextState, accounts: res.data.accounts });
          }
          setNumItems(res.data.recordCount);
         
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
        });
  }, [perPage, currentPage]);

  function paginate(num) {
    setCurrentPage(num);
  }
  
  return (
    <div className="manage-accounts">
      <ManageAccountHeader />

      <>
        {contextState.manageActivePage === "overview" && (
          <ManageAccountListPage 
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              perPage={perPage}
              setPerPage={setPerPage}
              currentPage={currentPage}
              numItems={numItems}
              paginate={paginate}
          />
        )}
        {contextState.manageActivePage === "download" && (
          <ManageAccountDownloadDataPage />
        )}
        {contextState.manageActivePage === "add" && (
          <ManageAccountAddAccountPage />
        )}
        {contextState.manageActivePage === "autopay" && (
          <ManageAccountAutoPayPage />
        )}
        {contextState.manageActivePage === "contact" && <ContactPage />}
      </>
    </div>
  );
}
